// extracted by mini-css-extract-plugin
export const swapContainer = "SwapTranspose-module__swap-container--PVvDY";